import $root from '../static/proto-bundle'

class ProtoBuilder {
  lookup(message) {
    return $root.lookup(message)
  }

  decode({ data }, message) {
    const container = $root.lookup(message)
    return container.decode(new Uint8Array(data))
  }
  create({ data }, message) {
    const builder = $root.lookup(message)
    return builder.create(data)
  }

  encode({ data }, message) {
    const builder = $root.lookup(message)
    const payload = builder.create(data)
    return builder.encode(payload).finish()
  }
}

export default ProtoBuilder
